
export default function NotFound() {

  return (
			<>
      <h1>404</h1>
      <p>Такой страницы не существует</p>
			</>
  );
}